/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GenerateCronScheduleRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {GenerateCronScheduleResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const generateCronSchedule = (request:GenerateCronScheduleRequest, options?: CashRequestOptions) => post<GenerateCronScheduleRequest, GenerateCronScheduleResponse>("/2.0/cash/generate-cron-schedule", request, {...options, rejectOnError: true })